<template>
	<div>
		<!-- 查询条件 -->
		<el-dialog title="分配设备" :visible.sync="dialogVisible" width="1210px" :close-on-click-modal="false" :before-close="handleClose">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>待选列表</span>
				</div>
				<el-col :span="24" class="handleQuery">
					<el-form :inline="true" :model="addOrUpdateForm" class="form" :rules="rules" size="mini" ref="addOrUpdateForm" label-width="70px">
						<el-form-item label="设备标签">
							<el-select v-model="queryParams.tags" filterable placeholder="请选择设备标签" style="width: 150px;">
								<el-option label="全部" value=""></el-option>
								<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="设备名称">
							<el-input v-model="queryParams.title" placeholder="请输入设备名称" style="width: 150px;"></el-input>
						</el-form-item>
						<el-button type="primary" size="mini" @click="handleQuery">查询</el-button>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table v-loading="loading" :data="datas" :height="420" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" size="mini"
						@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
						<el-table-column fixed type="selection" width="55" :selectable="selectable"></el-table-column>
						<el-table-column prop="title" label="设备名称"></el-table-column>
						<el-table-column prop="code" label="设备编号"></el-table-column>
						<el-table-column prop="tags" label="所属标签">
							<template slot-scope="scope" v-if="scope.row.tags">
								<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
									{{tag}}
								</el-tag>
							</template>
						</el-table-column>
					</el-table>
				</el-col>

				<el-pagination background layout="total, prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage" :small="true"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
				</el-col>
			</el-card>
			<div class="box-transfer">
				<el-button type="primary" size="mini" icon="el-icon-arrow-right" @click="right"></el-button>
				<el-button type="primary" size="mini" icon="el-icon-arrow-left" @click="left"></el-button>
			</div>
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>已选列表</span>
				</div>
				<el-col :span="24">
					<el-table v-loading="shareLoading" :data="shareData" :height="420" stripe border style="width: 100%" ref="shareMultipleTable" tooltip-effect="dark" size="mini"
						@selection-change="handleShareSelectionChange">
						<el-table-column fixed type="selection" width="55"></el-table-column>
						<el-table-column prop="title" label="设备名称"></el-table-column>
						<el-table-column prop="code" label="设备编号"></el-table-column>
						<el-table-column prop="tags" label="所属标签">
							<template slot-scope="scope" v-if="scope.row.tags">
								<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
									{{tag}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="code" label="可见变量" v-if="bizType=='user'">
							<template slot-scope="scope" v-if="scope.row.tags">
								<el-cascader  v-model="scope.row.variableIds" :options="scope.row.variableTagList" :props="props" collapse-tags clearable></el-cascader>
							</template>
						</el-table-column>
					</el-table>
				</el-col>

				<el-pagination background layout="total, prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]" :current-page="shareCurrentPage" size="mini"
					:page-size="sharePageSize" :total="shareTotal" @size-change="sharePageSizeChange" @current-change="shareCurrentChange"></el-pagination>
				</el-col>
			</el-card>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">取 消</el-button>
				<el-button size="small" type="primary" @click="saveShare">分 配</el-button>
			</div>
		</el-dialog>


	</div>
</template>
<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		name: 'devicesShare',
		props: ['bizType'],
		data() {
			return {
				url: 'devices',
				dialogVisible: false,
				bizId: null,
				allTags: [],
				shareLoading: false,
				shareCurrentPage: 1,
				sharePageSize: 10,
				shareTotal: 0,
				shareMultipleSelection: [],
				sourceTableData: [], // 原始数据
				sourceTableData2:[],
				shareData: [],
				autoQuery: false,
				props: {
					multiple: true
				},
				options: [{
					value: 1,
					label: '东南',
					children: [{
						value: 2,
						label: '上海'
					}, {
						value: 7,
						label: '江苏'
					}, {
						value: 12,
						label: '浙江'
					}]
				}, {
					value: 17,
					label: '西北',
					children: [{
						value: 18,
						label: '陕西'
					}, {
						value: 21,
						label: '新疆维吾尔族自治区'
					}]
				}]
			};
		},
		filters: {
			formatTriggerCondition(data) {
				if (data) {
					var condition = data.triggerCondition
					if (data.triggerCondition) {
						if (condition.includes('A')) {
							condition = condition.replace('A', data.a)
						}
						if (condition.includes('B')) {
							condition = condition.replace('B', data.b)
						}
						return condition
					}
				}
			},
			formatType(type) {
				if (type == "device") {
					return '设备'
				}
			}
		},
		methods: {
			handleClose() {
				this.dialogVisible = false;
			},
			show(bizId) {
				this.bizId = bizId
				this.dialogVisible = true;
				this.handleQuery();
				this.queryShareList();
			},
			queryTags() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'devices/queryTags',
					data: {},
				}).then(function(res) {
					that.allTags = res.data.data;
				})
			},
			queryShareList() {
				this.shareLoading = true
				if(this.bizType=='team'){
					this.queryAllShareList();
				}
				this.$http({
					method: 'POST',
					url: 'devices/queryShareList',
					data: {
						bizType: this.bizType,
						bizId: this.bizId
					},
				}).then((res) => {
					if (res.data.data) {
						this.sourceTableData = res.data.data;
					} else {
						this.sourceTableData = [];
					}
					this.shareCurrentChange(1)
					this.shareLoading = false;
				})
			},
			queryAllShareList() {
				this.$http({
					method: 'POST',
					url: 'devices/queryAllShareList',
					data: {
						bizType: this.bizType,
						bizId: this.bizId
					},
				}).then((res) => {
					if (res.data.data) {
						this.sourceTableData2 = res.data.data;
					} else {
						this.sourceTableData2 = [];
					}
				})
			},
			handleShareSelectionChange(val) {
				this.shareMultipleSelection = val;
			},
			sharePageSizeChange(newSize) {
				// 每页显示条数变化
				this.sharePageSize = newSize;
				this.shareCurrentPage = 1; // 重置到第一页
				this.updateTableData();
			},
			shareCurrentChange(newPage) {
				// 当前页码变化
				this.shareCurrentPage = newPage;
				this.updateTableData();
			},
			updateTableData() {
				// 根据分页参数更新表格数据
				const start = (this.shareCurrentPage - 1) * this.sharePageSize;
				const end = start + this.sharePageSize;
				this.shareData = this.sourceTableData.slice(start, end);
			},
			selectable(row, index) {
				return !this.sourceTableData.some(item => item.id === row.id) && !this.sourceTableData2.some(item => item.id === row.id);
			},
			right() {
				if (this.multipleSelection) {
					const selectedIds = this.multipleSelection.map(item => item.id);
					var selectedRows = this.datas.filter(item => selectedIds.includes(item.id));
					var copyList = JSON.parse(JSON.stringify(selectedRows));
					this.sourceTableData.splice(0, 0, ...copyList);
					this.shareTotal = this.sourceTableData.length;
					this.shareCurrentChange(1)
					this.$refs.multipleTable.clearSelection();
				}
			},
			left() {
				const selectedIds = this.shareMultipleSelection.map(item => item.id);
				this.sourceTableData = this.sourceTableData.filter(item => !selectedIds.includes(item.id));
				this.shareTotal = this.sourceTableData.length;
				this.shareCurrentChange(1)
			},
			saveShare() {
				var params = {
					bizType: this.bizType,
					bizId: this.bizId,
					devices: []
				}
				if (this.sourceTableData) {
					this.sourceTableData.forEach(item => {
						var uniqueElements ;
						if(item.variableIds){
							const secondElements = item.variableIds.map(item => item[1]);
							uniqueElements = [...new Set(secondElements)];
						}else{
							uniqueElements =[]
						}
						params.devices.push({
							deviceId:item.id,
							variableIds:uniqueElements
						})
					})
				}
				this.$http({
					method: 'POST',
					url: 'devices/share/create',
					data: params,
				}).then((res) => {
					if (res.data.errorCode == '0000') {
						this.successMessage('系统提示', '分配成功');
						this.handleClose()
					}
				})
			}
		},
		mounted: function() {
			this.queryParams.fillVariable=1
			this.queryTags();
		}

	}
</script>

<style scoped>
	/deep/ .el-dialog__body {
		display: inline-flex;
		padding-top: 0px !important;
		padding-bottom: 0px !important;
		padding-left: 10px;

		.form {
			margin: 10px 0px 10px 0px;
		}
	}

	.box-card {
		width: 565px;
		height: 640px;
		float: left;
		overflow-y: auto;
	}

	.el-card__body,
	.el-main {
		padding: 5px;
	}

	.el-dialog__body {
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.box-transfer {
		height: 600px;
		width: 60px;
		float: left;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0px !important;

		.el-button {
			margin-left: 0px !important;
			margin-top: 20px;
		}
	}

	/deep/ .handleQuery .el-select>.el-input {
		width: 150px !important;
	}

	.more {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/components/layout/devices/devicesShare.vue